import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/globalproperty";
const API_PATH_EXT = ConstantList.API_EN_POINT + "/global-property-ext";


export const pagingGlobalProperty = (obj) => axios.post(API_PATH + "/searchByPage", obj);

export const getGlobalPropertyById = (globalPropertyId) => axios.get(API_PATH_EXT + "/get-by-property/" + globalPropertyId);

export const saveGlobalProperty = globalProperty => axios.post(API_PATH, globalProperty);

export const updateGlobalProperty = globalProperty => axios.put(API_PATH + "/" + globalProperty?.id, globalProperty);

export const deleteGlobalProperty = globalPropertyId => axios.delete(API_PATH + '/' + globalPropertyId);

export const saveOrUpdateGlobalProperty = globalProperty => axios.post(API_PATH_EXT + "/save-or-update", globalProperty);

export const saveOrUpdatePropertyIsActive = globalProperty => axios.post(API_PATH_EXT + "/update-is-active", globalProperty);

export const pagingExtGlobalProperty = globalProperty => axios.post(API_PATH_EXT + "/search-by-page", globalProperty);

export const markDeleteGlobalProperty = property => axios.delete(API_PATH_EXT + "/mark-delete/" + property);